import axios from "axios";
import { getSessionId } from "./sessionStore";

export const X_SESSION_HEADER = "X-Session-Id";

export const isSessionHeaderEnabled = () => process.env.REACT_APP_SESSION_HEADER_ENABLED === "true";

let interceptorId = null;

export const setupSessionInterceptor = () => {
  if (interceptorId !== null) return interceptorId;

  interceptorId = axios.interceptors.request.use((config) => {
    try {
      const sessionId = getSessionId();
      if (sessionId && isSessionHeaderEnabled()) {
        if (!config.headers) config.headers = {};
        config.headers[X_SESSION_HEADER] = sessionId;
      }
    } catch (e) {
      return config;
    }
    return config;
  });

  return interceptorId;
};

export default setupSessionInterceptor;
